import { render, staticRenderFns } from "./VaucherHistory.vue?vue&type=template&id=38d3fc34&scoped=true"
import script from "./VaucherHistory.vue?vue&type=script&lang=js"
export * from "./VaucherHistory.vue?vue&type=script&lang=js"
import style0 from "./VaucherHistory.vue?vue&type=style&index=0&id=38d3fc34&prod&lang=scss&scoped=true"
import style1 from "./VaucherHistory.vue?vue&type=style&index=1&id=38d3fc34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3fc34",
  null
  
)

export default component.exports